var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"binds-table-alternate-header"}},[_c('div',{staticClass:"binds-table-alternate-header"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }